import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrganizationRoutingModule } from './organization-routing.module';
import { AddOrgComponent } from './components/add-org/add-org.component';
import { EditOrgComponent } from './components/edit-org/edit-org.component';
import { ViewOrgComponent } from './components/view-org/view-org.component';
import { OrgRootComponent } from './components/org-root/org-root.component';
import { ListOrgComponent } from './components/list-org/list-org.component';
import { SharedModule } from '../shared/shared.module';


@NgModule({
  declarations: [
    AddOrgComponent,
    EditOrgComponent,
    ViewOrgComponent,
    OrgRootComponent,
    ListOrgComponent
  ],
  imports: [
    CommonModule,
    OrganizationRoutingModule,
    SharedModule
  ]
})
export class OrganizationModule { }